import { SearchActionType } from '@modules/feed/store/searchActionType';
import { useSearchStore } from '@modules/feed/store/searchStore';
import { GetDashboardByTokenQuery } from 'generated/graphql';
import { useState } from 'react';
import useGetDashboard from 'v2/core/repository/edge-server/dashboard/useGetDashboard';
import { AndStatuses } from 'v2/core/repository/edge-server/types';
import useGetDashboardDeps from 'v2/core/services/dashboard/useGetDashboardDeps';
import useParseSavedSlugInfo from 'v2/core/services/savedSlug/useParseSavedSlugInfo';

export const useUpdateScheduleDataInStore = () => {
  const { token } = useParseSavedSlugInfo();
  const dispatch = useSearchStore(({ dispatch }) => dispatch);
  const {
    data: deps,
    status: dashboardDepsStatus,
    error: dashboardDepsFailedError,
  } = useGetDashboardDeps();

  const [shouldFetchSearchDashboard, setShouldFetchSearchDashboard] =
    useState(false);

  const {
    user: { id: userID },
    tenantID,
    timezone,
    sourceDetailsMap,
  } = deps ?? {};

  const onFetchDashboardSuccessCallback = (
    dashboard: GetDashboardByTokenQuery,
  ) => {
    if (!dashboardDepsFailedError) {
      dispatch({
        type: SearchActionType.SET_DATA,
        payload: {
          reportSchedule:
            dashboard.getDashboardByToken?.reporting?.secondarySchedules?.[0],
        },
      });

      setShouldFetchSearchDashboard(false);
    }
  };

  const { status: fetchDashboardStatus } = useGetDashboard(
    {
      token: token || '',
      tenantID,
      userID,
      sourceDetailsMap,
      includeScheduleOutbounds: true,
      timezone,
    },
    {
      Skip: !token || !sourceDetailsMap || !shouldFetchSearchDashboard,
      onCompleted: onFetchDashboardSuccessCallback,
    },
  );

  return {
    updateScheduleDataInStore: () => setShouldFetchSearchDashboard(true),
    status: AndStatuses([dashboardDepsStatus, fetchDashboardStatus]),
  };
};
